// extracted by mini-css-extract-plugin
export var closeButton = "_j4-1";
export var closeX = "_j4-3";
export var container = "_j4-0";
export var image = "_j4-2";